module.exports = __webpack_public_path__ + "img/print.36afa328.svg";